// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
   PromocionesInternet.css — pantalla /menu/promociones-internet
   ----------------------------------------------------------------------------
   EXCEPCION a "todo color sale de var(--sn-*)": los banners del carrusel son
   piezas de publicidad, como la web sisnetel.com, y deben verse IGUAL en tema
   claro y oscuro. Por eso usan los colores de marca medidos del logo
   (#a41619 rojo, #77070a rojo oscuro, #202930 grafito) y texto blanco, no los
   tokens del tema. Todo lo que está fuera del carrusel usa var(--sn-*).
   ============================================================================ */

/* ── Botón "Compartir" de la cabecera (secundario: grafito, no rojo) ──────── */

.pi-compartir {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--sn-superficie-2);
  border: 1px solid var(--sn-borde);
  border-radius: 999px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 700;
  color: var(--sn-texto-2);
  cursor: pointer;
}

.pi-compartir svg {
  font-size: 11px;
}

/* ── Carrusel ─────────────────────────────────────────────────────────────── */

.pi-carrusel {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  border-radius: 18px;
  box-shadow: var(--sn-sombra);
}

.pi-carrusel::-webkit-scrollbar {
  display: none; /* Chrome / WebView */
}

.pi-slide {
  flex: 0 0 100%;
  scroll-snap-align: start;
  position: relative;
  overflow: hidden;
  min-height: 196px;
  padding: 18px 18px 16px;
  border: none;
  text-align: left;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  background:
    radial-gradient(120% 90% at 100% 0%, rgba(164, 22, 25, 0.55) 0%, rgba(164, 22, 25, 0) 62%),
    linear-gradient(160deg, #2a343c 0%, #202930 45%, #12171b 100%);
}

/* Banner "El más pedido": rojo de marca */
.pi-slide--rojo {
  background:
    radial-gradient(90% 80% at 100% 100%, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 60%),
    linear-gradient(150deg, #a41619 0%, #77070a 68%, #4a0406 100%);
}

/* Banner "1 Giga": grafito casi negro, con brillo rojo abajo */
.pi-slide--noche {
  background:
    radial-gradient(110% 70% at 85% 110%, rgba(164, 22, 25, 0.6) 0%, rgba(164, 22, 25, 0) 65%),
    linear-gradient(200deg, #202930 0%, #12171b 55%, #0b0e11 100%);
}

/* El texto va por encima de las líneas de fibra decorativas */
.pi-slide > :not(.pi-slide-fibra) {
  position: relative;
  z-index: 1;
}

.pi-slide-kicker {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  padding: 3px 10px;
}

.pi-slide-cifra {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 12px;
  line-height: 0.9;
}

.pi-slide-previo {
  font-size: 14px;
  font-weight: 700;
  opacity: 0.85;
}

.pi-slide-numero {
  font-size: 64px;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.pi-slide-unidad {
  font-size: 18px;
  font-weight: 700;
  opacity: 0.92;
}

.pi-slide-texto {
  display: block;
  font-size: 12px;
  line-height: 1.4;
  opacity: 0.88;
  margin-top: 10px;
  max-width: 64%;
}

.pi-slide-pie {
  margin-top: auto;
  padding-top: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.pi-slide-precio {
  font-size: 13px;
  font-weight: 800;
  background: #fff;
  color: #202930;
  border-radius: 999px;
  padding: 5px 12px;
  white-space: nowrap;
}

.pi-slide-precio small {
  font-size: 11px;
  font-weight: 600;
  opacity: 0.75;
}

.pi-slide-accion {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

/* Líneas de fibra óptica con pulsos de luz que viajan por ellas */
.pi-slide-fibra {
  position: absolute;
  top: 0;
  right: -8px;
  width: 60%;
  height: 100%;
  pointer-events: none;
}

.pi-fibra-linea {
  fill: none;
  stroke: rgba(255, 255, 255, 0.16);
  stroke-width: 1.4;
}

.pi-fibra-pulso {
  fill: none;
  stroke: #ff6a6e;
  stroke-width: 2.4;
  stroke-linecap: round;
  stroke-dasharray: 16 240;
  animation: piPulso 3.4s linear infinite;
  filter: drop-shadow(0 0 4px rgba(255, 106, 110, 0.95));
}

.pi-slide--rojo .pi-fibra-pulso {
  stroke: #fff;
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.85));
}

.pi-fibra-pulso--2 { animation-delay: -1.1s; animation-duration: 2.9s; }
.pi-fibra-pulso--3 { animation-delay: -2.3s; animation-duration: 3.9s; }

@keyframes piPulso {
  from { stroke-dashoffset: 256; }
  to   { stroke-dashoffset: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .pi-fibra-pulso { animation: none; }
}

/* Puntos del carrusel: el botón es grande para el dedo, el punto es pequeño */
.pi-puntos {
  display: flex;
  justify-content: center;
  margin-top: 6px;
}

.pi-punto {
  background: none;
  border: none;
  padding: 0;
  width: 26px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.pi-punto span {
  display: block;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: var(--sn-borde-fuerte);
  transition: width 0.25s ease, background-color 0.25s ease;
}

.pi-punto--activo span {
  width: 18px;
  background: var(--sn-marca);
}

/* ── Lista de planes ──────────────────────────────────────────────────────── */

.pi-seccion-titulo {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--sn-texto-3);
  margin: 14px 0 8px;
}

.pi-planes {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.pi-plan {
  width: 100%;
  text-align: left;
  cursor: pointer;
  background: var(--sn-superficie);
  /* Siempre 2px para que al seleccionar no se mueva el diseño */
  border: 2px solid var(--sn-borde);
  border-radius: 14px;
  padding: 12px 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  scroll-margin: 90px 0 110px;
}

.pi-plan--activo {
  border-color: var(--sn-marca);
  box-shadow: var(--sn-sombra);
}

.pi-plan-cabecera {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.pi-plan-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  min-width: 0;
}

.pi-plan-radio {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid var(--sn-borde-fuerte);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pi-plan--activo .pi-plan-radio {
  border-color: var(--sn-marca);
}

.pi-plan--activo .pi-plan-radio::after {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--sn-marca);
}

.pi-plan-nombre {
  font-size: 17px;
  font-weight: 800;
  color: var(--sn-texto);
}

.pi-plan-etiqueta {
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  background: var(--sn-marca-suave);
  color: var(--sn-marca-texto);
  border-radius: 999px;
  padding: 2px 8px;
  white-space: nowrap;
}

.pi-plan-precio {
  text-align: right;
  white-space: nowrap;
  color: var(--sn-texto);
  line-height: 1.1;
}

.pi-plan-precio strong {
  font-size: 22px;
  font-weight: 800;
}

.pi-plan-precio span {
  display: block;
  font-size: 10px;
  color: var(--sn-texto-3);
}

.pi-plan-frase {
  display: block;
  font-size: 12px;
  color: var(--sn-texto-3);
  margin: 2px 0 0 26px;
}

.pi-velocidad {
  display: block;
  height: 5px;
  border-radius: 999px;
  background: var(--sn-superficie-3);
  margin: 10px 0;
  overflow: hidden;
}

.pi-velocidad span {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--sn-texto-2);
  transition: background-color 0.2s ease;
}

.pi-plan--activo .pi-velocidad span {
  background: var(--sn-marca);
}

/* Todo lo de la tarjeta son <span>: va dentro de un <button>, que solo admite
   contenido en línea. El display lo pone este CSS. */
.pi-beneficios {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px 10px;
}

.pi-beneficio {
  display: flex;
  align-items: flex-start;
  gap: 5px;
  font-size: 11px;
  line-height: 1.3;
  color: var(--sn-texto-2);
}

.pi-beneficio svg {
  flex-shrink: 0;
  margin-top: 2px;
  font-size: 9px;
  color: var(--sn-exito);
}

/* ── Qué incluyen todos los planes ────────────────────────────────────────── */

.pi-incluye {
  background: var(--sn-superficie);
  border: 1px solid var(--sn-borde);
  border-radius: 14px;
  padding: 12px 14px;
  margin-top: 14px;
}

.pi-incluye .pi-seccion-titulo {
  margin-top: 0;
}

.pi-incluye-lista {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.pi-incluye-lista li {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: var(--sn-texto-2);
  background: var(--sn-superficie-2);
  border: 1px solid var(--sn-borde);
  border-radius: 999px;
  padding: 4px 10px;
}

.pi-incluye-lista svg {
  font-size: 9px;
  color: var(--sn-exito);
}

.pi-nota {
  font-size: 11px;
  line-height: 1.4;
  color: var(--sn-texto-3);
  margin: 12px 0 4px;
}

/* ── Botón de WhatsApp fijo abajo (única acción roja de la pantalla) ──────── */

.pi-cta {
  position: sticky;
  bottom: 0;
  z-index: 5;
  background: var(--sn-superficie);
  border-top: 1px solid var(--sn-borde);
  padding: 10px 16px;
}

.pi-cta-boton {
  width: 100%;
  max-width: 468px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: none;
  border-radius: 12px;
  padding: 13px 16px;
  background: var(--sn-accion);
  color: var(--sn-accion-texto);
  font-size: 14px;
  font-weight: 800;
  box-shadow: var(--sn-sombra);
  cursor: pointer;
}

.pi-cta-boton:active {
  background: var(--sn-accion-hover);
}

.pi-cta-boton svg {
  font-size: 19px;
  flex-shrink: 0;
}

.pi-cta-boton small {
  font-size: 12px;
  font-weight: 600;
  opacity: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PromocionesInternet.css"],"names":[],"mappings":"AAAA;;;;;;;;iFAQiF;;AAEjF,gFAAgF;;AAEhF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,qBAAqB,EAAE,YAAY;EACnC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa,EAAE,qBAAqB;AACtC;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB;;kEAEgE;AAClE;;AAEA,0CAA0C;AAC1C;EACE;;kEAEgE;AAClE;;AAEA,+DAA+D;AAC/D;EACE;;kEAEgE;AAClE;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,wBAAwB;EACxB,uCAAuC;EACvC,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,sDAAsD;AACxD;;AAEA,qBAAqB,sBAAsB,EAAE,wBAAwB,EAAE;AACvE,qBAAqB,sBAAsB,EAAE,wBAAwB,EAAE;;AAEvE;EACE,OAAO,sBAAsB,EAAE;EAC/B,OAAO,oBAAoB,EAAE;AAC/B;;AAEA;EACE,kBAAkB,eAAe,EAAE;AACrC;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA,gFAAgF;;AAEhF;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,8DAA8D;EAC9D,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,wDAAwD;EACxD,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,kCAAkC;EAClC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;qDACqD;AACrD;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,gFAAgF;;AAEhF;EACE,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,gFAAgF;;AAEhF;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd","sourcesContent":["/* ============================================================================\n   PromocionesInternet.css — pantalla /menu/promociones-internet\n   ----------------------------------------------------------------------------\n   EXCEPCION a \"todo color sale de var(--sn-*)\": los banners del carrusel son\n   piezas de publicidad, como la web sisnetel.com, y deben verse IGUAL en tema\n   claro y oscuro. Por eso usan los colores de marca medidos del logo\n   (#a41619 rojo, #77070a rojo oscuro, #202930 grafito) y texto blanco, no los\n   tokens del tema. Todo lo que está fuera del carrusel usa var(--sn-*).\n   ============================================================================ */\n\n/* ── Botón \"Compartir\" de la cabecera (secundario: grafito, no rojo) ──────── */\n\n.pi-compartir {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--sn-superficie-2);\n  border: 1px solid var(--sn-borde);\n  border-radius: 999px;\n  padding: 5px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--sn-texto-2);\n  cursor: pointer;\n}\n\n.pi-compartir svg {\n  font-size: 11px;\n}\n\n/* ── Carrusel ─────────────────────────────────────────────────────────────── */\n\n.pi-carrusel {\n  display: flex;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none; /* Firefox */\n  border-radius: 18px;\n  box-shadow: var(--sn-sombra);\n}\n\n.pi-carrusel::-webkit-scrollbar {\n  display: none; /* Chrome / WebView */\n}\n\n.pi-slide {\n  flex: 0 0 100%;\n  scroll-snap-align: start;\n  position: relative;\n  overflow: hidden;\n  min-height: 196px;\n  padding: 18px 18px 16px;\n  border: none;\n  text-align: left;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  background:\n    radial-gradient(120% 90% at 100% 0%, rgba(164, 22, 25, 0.55) 0%, rgba(164, 22, 25, 0) 62%),\n    linear-gradient(160deg, #2a343c 0%, #202930 45%, #12171b 100%);\n}\n\n/* Banner \"El más pedido\": rojo de marca */\n.pi-slide--rojo {\n  background:\n    radial-gradient(90% 80% at 100% 100%, rgba(255, 255, 255, 0.16) 0%, rgba(255, 255, 255, 0) 60%),\n    linear-gradient(150deg, #a41619 0%, #77070a 68%, #4a0406 100%);\n}\n\n/* Banner \"1 Giga\": grafito casi negro, con brillo rojo abajo */\n.pi-slide--noche {\n  background:\n    radial-gradient(110% 70% at 85% 110%, rgba(164, 22, 25, 0.6) 0%, rgba(164, 22, 25, 0) 65%),\n    linear-gradient(200deg, #202930 0%, #12171b 55%, #0b0e11 100%);\n}\n\n/* El texto va por encima de las líneas de fibra decorativas */\n.pi-slide > :not(.pi-slide-fibra) {\n  position: relative;\n  z-index: 1;\n}\n\n.pi-slide-kicker {\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  background: rgba(255, 255, 255, 0.14);\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 999px;\n  padding: 3px 10px;\n}\n\n.pi-slide-cifra {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  margin-top: 12px;\n  line-height: 0.9;\n}\n\n.pi-slide-previo {\n  font-size: 14px;\n  font-weight: 700;\n  opacity: 0.85;\n}\n\n.pi-slide-numero {\n  font-size: 64px;\n  font-weight: 800;\n  letter-spacing: -0.04em;\n}\n\n.pi-slide-unidad {\n  font-size: 18px;\n  font-weight: 700;\n  opacity: 0.92;\n}\n\n.pi-slide-texto {\n  display: block;\n  font-size: 12px;\n  line-height: 1.4;\n  opacity: 0.88;\n  margin-top: 10px;\n  max-width: 64%;\n}\n\n.pi-slide-pie {\n  margin-top: auto;\n  padding-top: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.pi-slide-precio {\n  font-size: 13px;\n  font-weight: 800;\n  background: #fff;\n  color: #202930;\n  border-radius: 999px;\n  padding: 5px 12px;\n  white-space: nowrap;\n}\n\n.pi-slide-precio small {\n  font-size: 11px;\n  font-weight: 600;\n  opacity: 0.75;\n}\n\n.pi-slide-accion {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n/* Líneas de fibra óptica con pulsos de luz que viajan por ellas */\n.pi-slide-fibra {\n  position: absolute;\n  top: 0;\n  right: -8px;\n  width: 60%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.pi-fibra-linea {\n  fill: none;\n  stroke: rgba(255, 255, 255, 0.16);\n  stroke-width: 1.4;\n}\n\n.pi-fibra-pulso {\n  fill: none;\n  stroke: #ff6a6e;\n  stroke-width: 2.4;\n  stroke-linecap: round;\n  stroke-dasharray: 16 240;\n  animation: piPulso 3.4s linear infinite;\n  filter: drop-shadow(0 0 4px rgba(255, 106, 110, 0.95));\n}\n\n.pi-slide--rojo .pi-fibra-pulso {\n  stroke: #fff;\n  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.85));\n}\n\n.pi-fibra-pulso--2 { animation-delay: -1.1s; animation-duration: 2.9s; }\n.pi-fibra-pulso--3 { animation-delay: -2.3s; animation-duration: 3.9s; }\n\n@keyframes piPulso {\n  from { stroke-dashoffset: 256; }\n  to   { stroke-dashoffset: 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .pi-fibra-pulso { animation: none; }\n}\n\n/* Puntos del carrusel: el botón es grande para el dedo, el punto es pequeño */\n.pi-puntos {\n  display: flex;\n  justify-content: center;\n  margin-top: 6px;\n}\n\n.pi-punto {\n  background: none;\n  border: none;\n  padding: 0;\n  width: 26px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.pi-punto span {\n  display: block;\n  width: 6px;\n  height: 6px;\n  border-radius: 999px;\n  background: var(--sn-borde-fuerte);\n  transition: width 0.25s ease, background-color 0.25s ease;\n}\n\n.pi-punto--activo span {\n  width: 18px;\n  background: var(--sn-marca);\n}\n\n/* ── Lista de planes ──────────────────────────────────────────────────────── */\n\n.pi-seccion-titulo {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--sn-texto-3);\n  margin: 14px 0 8px;\n}\n\n.pi-planes {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.pi-plan {\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  background: var(--sn-superficie);\n  /* Siempre 2px para que al seleccionar no se mueva el diseño */\n  border: 2px solid var(--sn-borde);\n  border-radius: 14px;\n  padding: 12px 14px;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  scroll-margin: 90px 0 110px;\n}\n\n.pi-plan--activo {\n  border-color: var(--sn-marca);\n  box-shadow: var(--sn-sombra);\n}\n\n.pi-plan-cabecera {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.pi-plan-titulo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.pi-plan-radio {\n  flex-shrink: 0;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid var(--sn-borde-fuerte);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pi-plan--activo .pi-plan-radio {\n  border-color: var(--sn-marca);\n}\n\n.pi-plan--activo .pi-plan-radio::after {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--sn-marca);\n}\n\n.pi-plan-nombre {\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--sn-texto);\n}\n\n.pi-plan-etiqueta {\n  font-size: 9.5px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  background: var(--sn-marca-suave);\n  color: var(--sn-marca-texto);\n  border-radius: 999px;\n  padding: 2px 8px;\n  white-space: nowrap;\n}\n\n.pi-plan-precio {\n  text-align: right;\n  white-space: nowrap;\n  color: var(--sn-texto);\n  line-height: 1.1;\n}\n\n.pi-plan-precio strong {\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.pi-plan-precio span {\n  display: block;\n  font-size: 10px;\n  color: var(--sn-texto-3);\n}\n\n.pi-plan-frase {\n  display: block;\n  font-size: 12px;\n  color: var(--sn-texto-3);\n  margin: 2px 0 0 26px;\n}\n\n.pi-velocidad {\n  display: block;\n  height: 5px;\n  border-radius: 999px;\n  background: var(--sn-superficie-3);\n  margin: 10px 0;\n  overflow: hidden;\n}\n\n.pi-velocidad span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--sn-texto-2);\n  transition: background-color 0.2s ease;\n}\n\n.pi-plan--activo .pi-velocidad span {\n  background: var(--sn-marca);\n}\n\n/* Todo lo de la tarjeta son <span>: va dentro de un <button>, que solo admite\n   contenido en línea. El display lo pone este CSS. */\n.pi-beneficios {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 5px 10px;\n}\n\n.pi-beneficio {\n  display: flex;\n  align-items: flex-start;\n  gap: 5px;\n  font-size: 11px;\n  line-height: 1.3;\n  color: var(--sn-texto-2);\n}\n\n.pi-beneficio svg {\n  flex-shrink: 0;\n  margin-top: 2px;\n  font-size: 9px;\n  color: var(--sn-exito);\n}\n\n/* ── Qué incluyen todos los planes ────────────────────────────────────────── */\n\n.pi-incluye {\n  background: var(--sn-superficie);\n  border: 1px solid var(--sn-borde);\n  border-radius: 14px;\n  padding: 12px 14px;\n  margin-top: 14px;\n}\n\n.pi-incluye .pi-seccion-titulo {\n  margin-top: 0;\n}\n\n.pi-incluye-lista {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.pi-incluye-lista li {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--sn-texto-2);\n  background: var(--sn-superficie-2);\n  border: 1px solid var(--sn-borde);\n  border-radius: 999px;\n  padding: 4px 10px;\n}\n\n.pi-incluye-lista svg {\n  font-size: 9px;\n  color: var(--sn-exito);\n}\n\n.pi-nota {\n  font-size: 11px;\n  line-height: 1.4;\n  color: var(--sn-texto-3);\n  margin: 12px 0 4px;\n}\n\n/* ── Botón de WhatsApp fijo abajo (única acción roja de la pantalla) ──────── */\n\n.pi-cta {\n  position: sticky;\n  bottom: 0;\n  z-index: 5;\n  background: var(--sn-superficie);\n  border-top: 1px solid var(--sn-borde);\n  padding: 10px 16px;\n}\n\n.pi-cta-boton {\n  width: 100%;\n  max-width: 468px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  border: none;\n  border-radius: 12px;\n  padding: 13px 16px;\n  background: var(--sn-accion);\n  color: var(--sn-accion-texto);\n  font-size: 14px;\n  font-weight: 800;\n  box-shadow: var(--sn-sombra);\n  cursor: pointer;\n}\n\n.pi-cta-boton:active {\n  background: var(--sn-accion-hover);\n}\n\n.pi-cta-boton svg {\n  font-size: 19px;\n  flex-shrink: 0;\n}\n\n.pi-cta-boton small {\n  font-size: 12px;\n  font-weight: 600;\n  opacity: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
